/* -------------------------------------------------------------------------- */
/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */
export const MINE_PAGE_UUID = '33385b31-3dcc-4032-8f3b-63cdbeff6b8d'

/* -------------------------------------------------------------------------- */
/*                                    操作权限                                 */
/* -------------------------------------------------------------------------- */

// 管理港口
export const MINE_ACTION_UUID = '2e5e3605-304f-421c-851e-fd6865ac6d46'
